module.exports = __webpack_public_path__ + "onprem@2x.3772b6499d560b33f2fc568c8b7f8712.png";